import { useContext, useEffect } from 'react'
import Confetti from 'js-confetti'
import moment from 'moment'
import { CheckCircle } from '@mui/icons-material'
import { Box, Link } from '@mui/material'
import {
	convertToEnglishWordList,
	AuthContext,
	HighlightText,
	Typography
} from '@wolfdanepug/common-react'
import { AppContext } from '../context/app/AppContext'

export default function CheckoutSuccess({ data }: any) {
	const dogNames = data?.dogs
	const dogNamesString = convertToEnglishWordList(dogNames)
	const { setNavigationVisible, setLoading } = useContext(AppContext)
	const { restoreAuthSession } = useContext(AuthContext)

	useEffect(() => {
		setNavigationVisible(true)
		restoreAuthSession()
	}, [])

	useEffect(() => {
		const party = new Confetti()
		party.addConfetti()
	}, [])

	return (
		<>
			<Box sx={styles.root}>
				<Box sx={styles.content}>
					<CheckCircle sx={styles.icon} />
					<Typography
						variant="h1"
						sx={{
							fontSize: {
								xs: '2.2rem',
								md: '3rem'
							}
						}}
					>
						All Set!
					</Typography>
					<Typography sx={styles.welcome}>
						We are excited to welcome you{dogNames?.length > 1 ? ', ' : ' and '}
						{dogNamesString} <br />
						to the Wolf Dane Pug family. We know your pup{dogNames?.length > 1 ? 's' : ''} will love
						our gourmet dog food as much as our dogs do!
					</Typography>

					<Typography sx={{ fontSize: '1.1rem', textAlign: 'center' }}>
						Your first gourmet box will be shipped out the week of{' '}
						<HighlightText>
							{moment(data?.subscription?.estimatedDeliveryDate).format('MMMM Do')}
						</HighlightText>
						. You will receive a notification when your box has been shipped.
					</Typography>

					<Typography>
						Manage your subscription at any time from your{' '}
						<HighlightText>
							<Link href="/member/subscription">account</Link>
						</HighlightText>
						.
					</Typography>
				</Box>
				<Box sx={{ position: 'absolute', bottom: 0, left: 0, maxWidth: 400, zIndex: 0 }}>
					<Box
						component={'img'}
						src="https://static.wixstatic.com/media/1b43b4_86213d519bb749cbbb71d69e989dad10~mv2.jpg"
						alt="Subscription Success"
						sx={{ width: '100%' }}
					/>
				</Box>
			</Box>
		</>
	)
}

const styles = {
	root: {
		display: 'flex',
		flexDirection: 'column',
		alignItems: 'center',
		justifyContent: {
			xs: 'flex-start',
			md: 'center'
		},
		p: {
			xs: 3,
			md: 0
		},
		height: '100%',
		width: '100%'
	},
	content: {
		position: 'relative',
		display: 'flex',
		flexDirection: 'column',
		alignItems: 'center',
		maxWidth: 600,
		textAlign: 'center',
		zIndex: 1,
		gap: 3
	},
	icon: {
		width: {
			xs: 60,
			md: 80
		},
		height: {
			xs: 60,
			md: 80
		},
		color: 'success.main'
	},
	welcome: {
		textAlign: 'center',
		fontSize: {
			xs: '1.1rem',
			md: '1.3rem'
		}
	}
}
